<script setup lang="ts">
import BaseButton from "@/core/components/base/BaseButton.vue";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from "@/core/components/ui/dropdown-menu";
import {Attachment} from "@/attachment/interfaces/attachment";

defineProps<{ title: string; attachments: Attachment[] }>();
defineEmits(['onClick']);
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <BaseButton primary>
        {{ title }}
      </BaseButton>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" class="w-64" side="top">
      <div
        v-for="(attachment, index) in attachments"
        :key="attachment.id"
      >
        <DropdownMenuItem
          class="hover:bg-gray-100 cursor-pointer"
          @click="$emit('onClick', attachment.id)"
        >
          {{ attachment.title }}
        </DropdownMenuItem>
        <DropdownMenuSeparator v-if="index < attachments.length - 1 && attachments.length > 1" />
      </div>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
